<template>
  <mastery-modal
    v-if="studyGoal"
    class="study-goal-success-modal"
    header-image="boom.svg"
    :max-width="335"
    name="study-goal-success"
    primary-action-text="KEEP GOING"
    primary-action-variant="green"
    secondary-action-text="View Performance"
    title="BOOM!"
    type="masteryModalWhite"
    @primary-action-clicked="close"
    @secondary-action-clicked="viewPerformance"
  >
    <p class="success-text">
      {{ successText }}
    </p>
  </mastery-modal>
</template>

<script>
import MasteryModal from '@/components/ui/masteryModal.vue';

export default {
  components: { MasteryModal },
  computed: {
    isSimRoute() {
      if (!this.$route?.name) {
        return false;
      }
      return this.$route.name.startsWith('sims') || this.$route.name.startsWith('simSection') || this.$route.name.startsWith('simFlashcard');
    },
    studyGoal() {
      if (this.isSimRoute) {
        return false;
      }

      const user = this.$store.getters['session/currentUser'];
      return user?.userProfile?.studyGoal;
    },
    successText() {
      const question = this.studyGoal === 1 ? 'question' : 'questions';
      return `You answered ${this.studyGoal} ${question}!`;
    },
  },
  methods: {
    close() {
      this.$modal.hide('study-goal-success');
    },
    viewPerformance() {
      this.$router.push({ name: 'progress' });
      this.$modal.hide('study-goal-success');
    },
  },
};
</script>

<style lang="scss">
.study-goal-success-modal {
  .header-image {
    max-width: rem-calc(72);
  }

  .title {
    font-family: inherit !important;
    font-weight: $bold;
  }

  .content {
    margin-bottom: rem-calc(32);
  }

  .secondary-action {
    font-size: rem-calc(12);
    color: #000000;
    text-decoration: none;
    font-weight: normal;

    &:hover {
      text-decoration: underline;
    }
  }

  button.mastery-button {
    width: 100%;
    background-color: #00b46d;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .25);
  }
}
</style>
